"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeNativeEventListener = exports.addNativeEventListener = exports.registerNativeEventListeners = void 0;
// eslint-disable-next-line
function registerNativeEventListeners(Klass, events) {
    // For rax miniapp runtime babel plugins prev compile
}
exports.registerNativeEventListeners = registerNativeEventListeners;
function addNativeEventListener(eventName, callback) {
    document.addEventListener(eventName, callback);
}
exports.addNativeEventListener = addNativeEventListener;
function removeNativeEventListener(evetName, callback) {
    document.removeEventListener(evetName, callback);
}
exports.removeNativeEventListener = removeNativeEventListener;
